import { forwardRef, type Ref, type SVGProps } from "react";
const IconShieldCheckmarkFilledSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fillRule="evenodd"
      d="M16 2s3.26 2.015 5.5 3c1.459.642 3.719 1.352 5.117 1.77.758.226 1.319.867 1.355 1.658.09 1.908.034 5.787-1.293 10.697-1.694 6.27-7.89 9.607-9.983 10.574a1.64 1.64 0 0 1-1.392 0c-2.092-.966-8.288-4.303-9.983-10.574-1.327-4.91-1.382-8.789-1.293-10.697.037-.79.597-1.432 1.356-1.658C6.78 6.352 9.04 5.642 10.5 5c2.235-.983 5.488-2.992 5.5-3m5.658 9.247a1 1 0 0 0-1.411.095l-6.296 7.195-2.244-2.244a1 1 0 0 0-1.414 1.414l3 3a1 1 0 0 0 1.46-.049l7-8a1 1 0 0 0-.095-1.41"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = forwardRef(IconShieldCheckmarkFilledSVG);
ForwardRef.displayName = "IconShieldCheckmarkFilled";
export { ForwardRef as IconShieldCheckmarkFilled };
